import { useEffect } from 'react';
import { getLocalizedPrice, getPackageCosts } from '../utils/costs';

export const usePackages = ({ config, packages, paymentInterval, currency, locale, updatePackages, userData, useDecimalPlaces }) => {
	const allowMultiplePackages = config.allow_multiple_selection;

	// Create an object with the available packages
	const availablePackages = {};
	config.available_packages.map(({ id, state }) => {
		// Check if the package is published
		const consultingPackage = packages.find((item) => item.ID === id);
		if (consultingPackage) {
			availablePackages[consultingPackage.ID] = {
				key: consultingPackage.key,
				name: consultingPackage.name,
				content: {
					description: consultingPackage.description,
					includes: consultingPackage.includes,
					duration: consultingPackage.duration,
				},
				required: state === 'required',
				included: state === 'included',
				recurringCosts: consultingPackage.cost_type === 'recurring',
				recommended: config.recommended_package === consultingPackage.ID,
				costs: getLocalizedPrice(getPackageCosts(consultingPackage, state, paymentInterval, useDecimalPlaces), currency, locale),
			};
		}
	});

	const addPackage = (packageID) => {
		if (allowMultiplePackages) {
			updatePackages([...userData.packages, packageID]);
		} else {
			// Determine which packages are required or included
			const fixedPackageKeys = Object.entries(availablePackages)
				.filter(([, value]) => value.required || value.included)
				.map(([key]) => parseInt(key));
			// Add the selected package to the list of required or included packages
			updatePackages([...fixedPackageKeys, packageID]);
		}
	};

	const removePackage = (packageID) => {
		updatePackages(userData.packages.filter((key) => key !== packageID));
	};

	const resetPackages = () => {
		updatePackages([]);
	};

	useEffect(() => {
		const activePackages = [];

		// Add all required and included packages to the list of selected packages
		Object.entries(availablePackages).forEach(([key, value]) => {
			const packageID = parseInt(key);
			if ((value.included || value.required) && !userData.packages.includes(packageID)) {
				activePackages.push(packageID);
			}
		});

		// Handle default package when only one package is allowed and no package is selected
		if (!allowMultiplePackages && !userData.packages.length) {
			const optionalPackages = Object.entries(availablePackages)
				.filter(([, value]) => !value.included && !value.required)
				.map(([key]) => parseInt(key));

			// Add the recommended package or the first optional package if a package is required
			if (optionalPackages.length) {
				const recommendedPackageIsAvailable = Object.keys(availablePackages).includes(config.recommended_package.toString());
				if (recommendedPackageIsAvailable) {
					// Add the recommended package
					activePackages.push(config.recommended_package);
				} else if (config.package_required) {
					// Add the first optional package
					activePackages.push(optionalPackages[0]);
				}
			}
		}

		updatePackages([...userData.packages, ...activePackages]);
	}, []);

	return { availablePackages, addPackage, removePackage, resetPackages };
};
